import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import TextField from 'material-ui/TextField'
import Toggle from 'material-ui/Toggle'
import Arrow from 'material-ui/svg-icons/hardware/keyboard-arrow-right'
import RaisedButton from 'material-ui/RaisedButton'
import { FormattedMessage } from 'react-intl'
import { ForgotDetailsLink, LogginButton } from './styles'

const toggleStyle = {
  thumbSwitched: {
    backgroundColor: '#88E0A8'
  },
  thumbOff: {
    backgroundColor: '#46CE90'
  }
}

class LoginForm extends Component {
  constructor (props) {
    super(props)

    this.state = {
      email: localStorage.getItem('loginEmail'),
      password: localStorage.getItem('loginPassword'),
      emailError: false,
      passwordError: false
    }
  }

  handleSubmit = e => {
    const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
    if (iOS) {
      window.location = 'https://itunes.apple.com/jp/app/workshop-mobile/id1325343868?l=jp&mt=8'
      return
    }

    const Android = /android|Android/.test(navigator.userAgent)
    if (Android) {
      window.location = 'https://play.google.com/store/apps/details?id=com.fvwebinar'
      return
    }

    e.preventDefault()
    this.props.shouldRedirectUser(false)
    this.props.shouldRedirectUserToLogin(false)
    this.props.logoutRequestResult(false)
    let post = true
    let {remember} = this.refs

    if (this.state.email.length === 0) {
      this.setState({emailError: true})
      post = false
    } else {
      this.setState({emailError: false})
    }

    if (this.state.password.length === 0) {
      this.setState({passwordError: true})
      post = false
    } else {
      this.setState({passwordError: false})
    }

    if (post) {
      this.props.loginUser(
        this.state.email,
        this.state.password,
        remember.state.switched
      )
    }
  }

  render () {
    if (this.props.loginStatus) {
      if ((this.props.user.plan !== 'free_guest' && this.props.user.plan !== 'guest')) {
        return (
          <Redirect
            to={'/admin'}
          />
        )
      } else {
        return (
          <Redirect
            to={'/'}
          />
        )
      }
    }
    return (
      <form autoComplete="off" onSubmit={this.handleSubmit}>
        <div className="mb4">
          <input style={{display: 'none'}} type="text" name="username"/>
          <input style={{display: 'none'}} type="password" name="password"/>
          <TextField
            hintText="abc@abc.com"
            floatingLabelText={<FormattedMessage id="login.emailLable"/>}
            type="email"
            fullWidth
            errorText={
              this.state.emailError ? (
                <FormattedMessage id="login.requiredField"/>
              ) : null
            }
            name="username"
            value={this.state.email}
            onChange={(e) => this.setState({email: e.target.value})}
            ref="email"
          />
          <TextField
            hintText="*******"
            floatingLabelText={<FormattedMessage id="login.passwordLable"/>}
            fullWidth
            errorText={
              this.state.passwordError ? (
                <FormattedMessage id="login.requiredField"/>
              ) : null
            }
            type="password"
            name="password"
            value={this.state.password}
            onChange={(e) => this.setState({password: e.target.value})}
          />
        </div>
        <div className="flex justify-between mb4 login-actions">
          <div className="w-100 flex flex-row items-center">
            <Toggle
              label={<FormattedMessage id="login.remember"/>}
              labelPosition="right"
              thumbSwitchedStyle={toggleStyle.thumbOff}
              trackSwitchedStyle={toggleStyle.thumbSwitched}
              labelStyle={{
                fontSize: '14px',
                lineHeight: '20px',
                color: 'rgba(107, 124, 147, 0.54)',
                opacity: 1
              }}
              ref="remember"
            />
          </div>
          <LogginButton className="w-50 flex flex-row-reverse login-button">
            <RaisedButton type="submit" backgroundColor="#45CE90">
              <div className="flex justify-center">
                <span className="pl2 white-90 flex justify-center items-center">
                  <FormattedMessage id="login.buttonLabel"/>
                </span>
                <span className="white-90 flex justify-center items-center">
                  <Arrow color="#fff"/>
                </span>
              </div>
            </RaisedButton>
          </LogginButton>
        </div>
        <div onClick={() => this.props.authErrors([])} className="tc mb3">
          <ForgotDetailsLink
            to={'/signup'}
          >
            <FormattedMessage id="login.newAccountLabel"/>
          </ForgotDetailsLink>
        </div>
        <div onClick={() => this.props.authErrors([])} className="tc mb3">
          <ForgotDetailsLink
            to={'/forgot-password'}
          >
            <FormattedMessage id="login.forgotPassword"/>
          </ForgotDetailsLink>
        </div>
      </form>
    )
  }
}

export default LoginForm



// WEBPACK FOOTER //
// ./src/components/LoginForm/LoginForm.js